var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSection2ItemBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 68,
    viewBox: "0 0 113 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9624 9.06054L1 65H61.3944C64.334 64.9994 67.2244 64.2581 69.7896 62.8469C72.3547 61.4358 74.5089 59.4019 76.0464 56.9395L111 1H50.6144C47.6748 1.00062 44.7844 1.74191 42.2192 3.15307C39.6541 4.56423 37.4999 6.59813 35.9624 9.06054V9.06054Z",
    stroke: "url(#paint0_linear_911_355)",
    strokeOpacity: 0.8,
    strokeMiterlimit: 10,
    strokeDasharray: "3 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7081 12.0605L2.75452 68H63.1401C66.0788 67.9995 68.9683 67.2591 71.5332 65.8496C74.0981 64.4401 76.2529 62.4083 77.7921 59.9481L112.755 4H52.3601C49.4205 4.00062 46.5301 4.74191 43.9649 6.15307C41.3998 7.56423 39.2456 9.59813 37.7081 12.0605Z",
    fill: "#323232"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_911_355",
    x1: 133.295,
    y1: 33,
    x2: 36.8431,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#781D95",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#6E1D92",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#521E89",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#261F7A",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152075"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2ItemBackground);
export default __webpack_public_path__ + "static/media/section2itemBackground.46f1a8947c846bff29aab55b66534cf5.svg";
export { ForwardRef as ReactComponent };